module.exports = __webpack_public_path__ + "static/media/md.4f70fc7d.svg";